// extracted by mini-css-extract-plugin
module.exports = {"rate":"RateButton_rate__3b3Ig","selected":"RateButton_selected__2Wrv7","first":"RateButton_first__tqqBY","last":"RateButton_last__N9KyZ","border":"RateButton_border__3eQTb"};